import basicController from "servicestack/basic.controller.properties";
import $resolve from "ng";
import modals from "webmodals/modals";

export default class UserMarketingProfilePromptController {
  constructor() {
    const $ctrl = this;
    basicController($ctrl);
    $ctrl.bus = $ctrl.$session.bus;
    delete $ctrl.bus.validationErrors;
    this.bus
      .read("GetKlaviyoProfile.json", {email: $ctrl.user.primaryEmail})
      .then((r) => {
            $ctrl.profile = JSON.parse(r.data);
            $ctrl.attributes = $ctrl.profile.data[0].attributes;
            $ctrl.properties = $ctrl.profile.data[0].attributes.properties;
            $ctrl.propertyKeys = Object.keys($ctrl.properties).filter(k => k.indexOf("EMUN_") == -1);
            $ctrl.emunPropertyKeys = Object.keys($ctrl.properties).filter(k => k.indexOf("EMUN_") == 0);
            $ctrl.eventsLoading = true;
            this.bus.read("GetKlaviyoMetrics").then((res) => {
              $ctrl.metrics = JSON.parse(res.data);
              this.bus.read("GetKlaviyoEvents", {id: $ctrl.profile.data[0].id}).then((res) => {
                $ctrl.events = JSON.parse(res.data);
                $ctrl.events.data.forEach(function(event) {
                    var metrics = $ctrl.metrics.data.filter(m => m.id == event.attributes.metric_id);
                    if (metrics.length) event.metric_name = metrics[0].attributes.name;
                    event.propertyKeys = Object.keys(event.attributes.event_properties);
                    event.isCollapsed = true;
                });
                $ctrl.filterEvents("ALL");
                $ctrl.selectedMetric = "ALL";
                $ctrl.eventsLoading = false;
              });
            });
      });

  }

  updateProfile() {
    let $ctrl = this;
    var profileData = {
      data: {
        type: "profile",
        id: $ctrl.profile.data[0].id,
        attributes: {
          email: $ctrl.profile.data[0].attributes.email,
          properties: $ctrl.profile.data[0].attributes.properties
        }
      }
    }
    $ctrl.bus.send("UpdateKlaviyoProfile", {
      ProfileId: $ctrl.profile.data[0].id,
      ProfileData: JSON.stringify(profileData)
    }).then(res => modals.alert("Profile updated succesfully"));
  }

  addProperty() {
    let $ctrl = this;
    modals.prompt('Add Property...')
    .result
    .then(propName => {
      $ctrl.profile.data[0].attributes.properties["EMUN_" + propName] = "";
      $ctrl.emunPropertyKeys = Object.keys($ctrl.properties).filter(k => k.indexOf("EMUN_") == 0);
    });
  }

  filterEvents(metricName) {
    let $ctrl = this;
    if (metricName == "ALL") $ctrl.filteredEvents = $ctrl.events.data.filter(e => e.metric_name != "");
    else $ctrl.filteredEvents = $ctrl.events.data.filter(e => e.metric_name == metricName);
  }

}
